import App from "./App.svelte";
import ContactUs from "./components/ContactUs.svelte";
import { initOnce } from "./utils";
initOnce(".hallo-boks-settings", (appEl) => {
    const app = new App({
        target: appEl,
    });
});
initOnce(".sa-contact-us", (appEl) => {
    var _a;
    const app = new ContactUs({
        target: appEl,
        props: {
            config: (_a = JSON.parse(decodeURI(appEl.getAttribute("data-config")))) !== null && _a !== void 0 ? _a : {
                title: "Har du tips i saken?",
                subtitle: "Kontakt oss!",
                text: "Har du innspill, eller egne erfaringer om dette temaet - da vil vi gjerne høre fra deg!",
                thanks: "Vennlig hilsen",
                viewPhone: true,
                viewEmail: true,
                journalists: [
                    {
                        name: "Camilla Bjørheim",
                        image: "https://cdn.aftenbladet.no/sa/portrett/square/camilla-bjorheim.jpg",
                        email: "camilla.bjorheim@aftenbladet.no",
                        phone: "+47 905 00 00",
                    },
                    {
                        name: "Julie Teresa Olsen",
                        image: "https://cdn.aftenbladet.no/sa/portrett/square/julie-teresa-olsen.jpg",
                        email: "julie.teresa.olsen@aftenbladet.no",
                        phone: "+47 905 00 01",
                    },
                    {
                        name: "Klaus Gustafsson",
                        image: "https://cdn.aftenbladet.no/sa/portrett/square/klaus-gustafsson.jpg",
                        email: "klaus.gustafsson@aftenbladet.no",
                        phone: "+47 905 00 02",
                    },
                ],
            },
        },
    });
});
initOnce(".sa-hallo", (appEl) => {
    var _a;
    const app = new ContactUs({
        target: appEl,
        props: {
            config: (_a = JSON.parse(decodeURI(appEl.getAttribute("data-config")))) !== null && _a !== void 0 ? _a : {
                title: "Har du tips i saken?",
                subtitle: "Kontakt oss!",
                text: "Har du innspill, eller egne erfaringer om dette temaet - da vil vi gjerne høre fra deg!",
                thanks: "Vennlig hilsen",
                viewPhone: true,
                viewEmail: true,
                journalists: [
                    {
                        name: "Camilla Bjørheim",
                        image: "https://cdn.aftenbladet.no/sa/portrett/square/camilla-bjorheim.jpg",
                        email: "camilla.bjorheim@aftenbladet.no",
                        phone: "+47 905 00 00",
                    },
                    {
                        name: "Julie Teresa Olsen",
                        image: "https://cdn.aftenbladet.no/sa/portrett/square/julie-teresa-olsen.jpg",
                        email: "julie.teresa.olsen@aftenbladet.no",
                        phone: "+47 905 00 01",
                    },
                    {
                        name: "Klaus Gustafsson",
                        image: "https://cdn.aftenbladet.no/sa/portrett/square/klaus-gustafsson.jpg",
                        email: "klaus.gustafsson@aftenbladet.no",
                        phone: "+47 905 00 02",
                    },
                ],
            },
        },
    });
});
